import React, { useEffect } from 'react';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/900.css';

import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../sections/HeroSection';
import SocialProofSection from '../sections/SocialProofSection';
import AboutSection from '../sections/AboutSection';
import ExperienceSection from '../sections/ExperienceSection';
import AIMatchmakingSection from '../sections/AIMatchmakingSection';
import OpportunitiesSection from '../sections/OpportunitiesSection';
import AgendaSection from '../sections/AgendaSection';
import PricingSection from '../sections/PricingSection';
import ProductsBentoSection from '../sections/ProductsBentoSection';
import FAQSection from '../sections/FAQSection';
import FinalCTASection from '../sections/FinalCTASection';
import TelegramContactSection from '../sections/TelegramContactSection';

const LandingPage = () => {
  useEffect(() => {
    document.title = 'LayerSeek · DeFi Protocol Summit · Nov 20, 2026';
  }, []);

  return (
    <div className="min-h-screen bg-[var(--bg-primary)]">
      <Header />
      <main>
        <HeroSection />
        {/* SocialProofSection hidden for now */}
        <AboutSection />
        <section id="experience">
          <ExperienceSection />
        </section>
        <AIMatchmakingSection />
        <OpportunitiesSection />
        <section id="schedule">
          <AgendaSection />
        </section>
        <PricingSection />
        <ProductsBentoSection />
        <section id="faq">
          <FAQSection />
        </section>
        <TelegramContactSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;